import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'PlaceholderCover',
  props: {
    color: { default: '#96a1b0' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "placeholder-cover",
    style: _normalizeStyle({ '--cover-color': __props.color }),
    viewBox: "0 0 110 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9 146h94a6.999 6.999 0 0 0 7-7V7a7.003 7.003 0 0 0-7-7H9v146Z",
      fill: "var(--cover-color)"
    }, null, -1),
    _createElementVNode("path", {
      d: "M59.5 18C74.688 18 87 30.312 87 45.5v4.998c6.68 5.017 11 13.005 11 22.002 0 8.997-4.32 16.985-11 22.002v5.998c0 15.188-12.312 27.5-27.5 27.5S32 115.688 32 100.5v-5.998C25.32 89.485 21 81.497 21 72.5c0-8.997 4.32-16.985 11-22.002V45.5C32 30.312 44.312 18 59.5 18Z",
      fill: "#fff",
      "fill-opacity": ".6"
    }, null, -1),
    _createElementVNode("path", {
      d: "M82 78H37m45-10H37m37 20H45m29-30H45",
      stroke: "#141C31",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M0 7a7 7 0 0 1 7-7h2v146H7a6.999 6.999 0 0 1-7-7V7Z",
      fill: "#141C31"
    }, null, -1)
  ]))], 4))
}
}

})